import React, {VoidFunctionComponent} from 'react';
import cx from 'classnames';

import IconButton from '../../icon-button/icon-button';
import FilterIcon from '../../icons/filter/filter-icon';
import {useFilters} from '../../../../hooks/useFilters';

import styles from './filter-icon-button.module.css';

const FilterIconButton: VoidFunctionComponent = () => {
  const {filterIsOpen, toggleFilterPanel} = useFilters();

  return (
    <IconButton
      variant="secondary"
      className={cx(styles.filterIconButton, filterIsOpen && styles.isActiveButton)}
      onClick={toggleFilterPanel}>
      <FilterIcon
        className={cx(styles.filterIcon, filterIsOpen && styles.isActiveIcon)}
      />
    </IconButton>
  );
};
export default FilterIconButton;
